import { ref } from "vue";
const sitedData = ref({
  groupID: "", // 课群ID
  user: {
    // 用户信息
    tel: "", // 手机号
    password: "", // 密码
    sessionID: "", // sessionID
    userID: "", // 用户ID
    userInfo: "", // 用户信息
    yibanID: "", // 易班ID
    userToken: "", // 易班token
  },
  order: {
    // 订单信息
    orderID: "", // 订单ID
    orderPrice: "", // 订单价格
    groupTitle: "", // 课群标题
    groupImg: "", // 课群图片
    examTitle: "", // 试卷标题
    targetScores: "", // 目标分数
    maxScores: "", // 最大分数
    targetExamTime: "", // 目标考试时间
    maxExamTime: "", // 最大时间
    examId: "", // 试卷ID
    alipay: {
      id: "",
      qrCode: "",
    },
  },
  Step: 0, // 当前步骤
  page1_Step1: 0, // 第一页面的步骤1
  page1_Step2: 0, // 第一页面的步骤2
  page1_StepState: false, // 第一页面的步骤状态
  page2_StepState: false,
  showIntro: false, // 是否显示介绍
});
export const useData = () => {
  return { sitedData };
};
